import axios from 'axios'
import { Message } from 'element-ui'
import apiEnv from '@/api/env'
import { clearAuthStorage, getToken } from './auth'

// 避免登录失效时重复跳转
let isRedirecting = false

const service = axios.create({
  baseURL: apiEnv.baseURL,
  timeout: 180000,
  headers: {
    // 后端接口统一接收表单参数
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// 请求拦截：在请求头 userzqsx 中携带登录返回的 aesUser 凭证，后端据此解析当前登录用户
// 注：zqsx 模块鉴权头为 userzqsx（ZqsxUserUtils.getUser 读取该头）
service.interceptors.request.use(
  config => {
    const token = getToken()
    // 文件流上传时交给浏览器自动补齐 multipart boundary
    if (config.data instanceof FormData && config.headers) {
      delete config.headers['Content-Type']
    }
    if (token) {
      config.headers.userzqsx = token
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    // 文件流响应（导出等场景）直接返回 blob 数据
    if (response.config.responseType === 'blob') {
      return response.data
    }
    const res = response.data || {}
    // 后端统一返回结构：status=200 且 result=success 视为成功
    if (res.status === 200 && res.result === 'success') {
      return res
    }

    const message = res.msg || '请求失败，请稍后重试'
    Message.error(message)

    // 登录失效（status=401 或提示文案命中）时清理本地登录态并跳转登录页
    if (res.status === 401 || message.includes('登录失效') || message.includes('重新登录')) {
      clearAuthStorage()
      if (!isRedirecting && window.location.hash !== '#/login') {
        isRedirecting = true
        window.location.hash = '#/login'
        window.setTimeout(() => {
          isRedirecting = false
        }, 300)
      }
    }

    return Promise.reject(new Error(message))
  },
  error => {
    const message = error.message || '网络异常，请稍后重试'
    Message.error(message)
    return Promise.reject(error)
  }
)

export default service
